export const projects = [
  {
    title: 'Emmy — AI Psychology Platform',
    description:
      'AI-powered online psychology platform with personalized AI psychologists, real-time chat sessions, emotional tracking, session history, and progress analytics.',
    problem: 'Many mental health tools feel generic and do not help users track emotional patterns over time.',
    solution: 'Designed a full-stack platform with personalized AI chat flows, emotional tracking, and structured user progress history.',
    impact: 'Created a foundation for human-centered AI support with a warmer and more reflective user experience.',
    technologies: ['Django', 'React', 'Docker', 'Vector Database', 'JWT', 'REST API'],
    links: { github: 'https://github.com/NeVajnoKak?tab=repositories', demo: '#', caseStudy: '#' }
  },
  {
    title: 'ToStruct — Data Visualization and Structuring Platform',
    description:
      'Platform combining graph and relational databases for flexible querying, visualization, and structured data exploration.',
    problem: 'Complex relationships are difficult to model and explore with a single database approach.',
    solution: 'Combined Neo4j and PostgreSQL with a React TypeScript interface for flexible data exploration.',
    impact: 'Improved the clarity of relationship-heavy data and supported multiple querying patterns.',
    technologies: ['Django', 'React TypeScript', 'Go', 'Neo4j', 'PostgreSQL', 'Docker'],
    links: { github: 'https://github.com/NeVajnoKak?tab=repositories', demo: '#', caseStudy: '#' }
  },
  {
    title: 'Portfolio / Academic Website',
    description:
      'Personal academic portfolio designed to present research interests, technical projects, and graduate school readiness.',
    problem: 'Graduate applications need a clear digital profile that communicates research direction and technical credibility.',
    solution: 'Built a clean academic portfolio with research interests, selected projects, resume, and contact sections.',
    impact: 'Improves first impressions for professors, reviewers, recruiters, and academic collaborators.',
    technologies: ['React', 'TailwindCSS', 'Framer Motion'],
    links: { github: 'https://github.com/NeVajnoKak?tab=repositories', demo: '#', caseStudy: '#' }
  },
  {
    title: 'Interactive 2D Game Prototype',
    description:
      'A 2D interactive game prototype focused on character movement, sprite animation, and atmospheric storytelling.',
    problem: 'Interactive storytelling requires responsive mechanics, consistent visual systems, and readable character animation.',
    solution: 'Explored movement, sprite slicing, animation states, and Unity physics for a polished prototype foundation.',
    impact: 'Developed a stronger understanding of gameplay systems, visual feedback, and interaction design.',
    technologies: ['Unity', 'C#', '2D Sprite Systems'],
    links: { github: 'https://github.com/NeVajnoKak?tab=repositories', demo: '#', caseStudy: '#' }
  }
]
